import { render, staticRenderFns } from "./VerLayout.vue?vue&type=template&id=76915e8a"
import script from "./VerLayout.vue?vue&type=script&lang=js"
export * from "./VerLayout.vue?vue&type=script&lang=js"
import style0 from "./VerLayout.vue?vue&type=style&index=0&id=76915e8a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports